const weightMask = {
    name: 'numeric',
    options: {
        placeholder: '0',
        allowMinus: false,
        rightAlign: false,
        autoUnmask: true,
        unmaskAsNumber: true,
        inputtype: "number",
        suffix: BX.message('WEIGHT_MASK'),
    }
}

const sizeMask = {
    name: 'integer',
    options: {
        placeholder: '0',
        allowMinus: false,
        rightAlign: false,
        unmaskAsNumber: true,
        inputtype: "number",
        suffix: BX.message('SIZE_MASK'),
    }
}
const integerMask = {
    name: 'integer',
    options: {
        placeholder: '0',
        allowMinus: false,
        rightAlign: false,
        autoUnmask: true,
        unmaskAsNumber: true,
        inputtype: "number",
    }
}

const amountMask = {
    name: 'integer',
    options: {
        min: 10,
        max: 999999,
        SetMaxOnOverflow: true,
        allowMinus: false,
        rightAlign: false,
        autoUnmask: true,
        unmaskAsNumber: true,
        inputtype: "number",
    }
}

const phoneMask = {
    name: '+7 (999) 999 99-99',
    options: {
        autoUnmask: true,
        placeholder: '+7 (___) ___ __-__',
        onUnMask: (maskedValue) => {
            return maskedValue.replaceAll(/\D/gi, '');
        },
        onBeforePaste: (pastedValue) => {
            if (pastedValue.length === 11) {
                if (pastedValue.match(/7|8/).index === 0) return pastedValue.substring(1)
            }
            return pastedValue;
        },
        onBeforeMask: (value) => {
            if (value.length === 11) {
                if (value.match(/7|8/).index === 0) return value.substring(1)
            }
            return value;
        }
    }
};

const emailMask = {
    name: 'email',
};

export { integerMask, phoneMask, emailMask, sizeMask, weightMask, amountMask }